const state = {
  // Список пользователей
  users: [],

  // Общее количество
  total: 0,

  // Флаг показывающий загружается ли сейчас страница
  isLoading: false,
};

export default state;
